import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=2008075c&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=ts&"
export * from "./Paginator.vue?vue&type=script&lang=ts&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=2008075c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008075c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
